<div class="dialog-container">
  @if (isLoading) {
    <div class="loading-wrapper">
      <mat-progress-spinner
        color="primary"
        mode="indeterminate"
        diameter="32"></mat-progress-spinner>
    </div>
  } @else if (step === 'form') {
    <div class="text-container">
      <span class="font-medium-display-small text-align-center">
        Vertrag widerrufen
      </span>
      <span class="font-regular-body-large text-align-center">
        Bitte gib deine Daten und die Buchungsnummer der Buchung an, die du
        widerrufen möchtest.
      </span>
    </div>
    <form
      class="form-container"
      [formGroup]="revocationForm"
      (ngSubmit)="lookupBooking()">
      <div class="formular-row-2-inputs align-self-stretch">
        <div class="input-simple flex-1-0-0">
          <div class="input-label" for="firstName">
            Vorname{{
              fieldRequired(revocationForm.get('firstName')) ? '*' : ''
            }}
          </div>
          <input
            id="firstName"
            class="input-field"
            formControlName="firstName"
            name="firstName"
            type="text"
            autocomplete="given-name"
            placeholder="Vorname" />
          <app-error-message
            [formField]="revocationForm.get('firstName')"></app-error-message>
        </div>
        <div class="input-simple flex-1-0-0">
          <div class="input-label" for="lastName">
            Nachname{{
              fieldRequired(revocationForm.get('lastName')) ? '*' : ''
            }}
          </div>
          <input
            id="lastName"
            class="input-field"
            formControlName="lastName"
            name="lastName"
            type="text"
            autocomplete="family-name"
            placeholder="Nachname" />
          <app-error-message
            [formField]="revocationForm.get('lastName')"></app-error-message>
        </div>
      </div>
      <div class="input-simple align-self-stretch">
        <div class="flex-c">
          <div class="input-label" for="bookingNumber">
            Buchungsnummer{{
              fieldRequired(revocationForm.get('bookingNumber')) ? '*' : ''
            }}
          </div>
          <p class="booking-number-hint">
            Die Buchungsnummer findest Du in der E-Mail "Buchungsbestätigung"
            und auf Deiner Rechnung
          </p>
        </div>
        <input
          id="bookingNumber"
          class="input-field"
          formControlName="bookingNumber"
          name="bookingNumber"
          type="text"
          placeholder="Buchungsnummer" />
        <app-error-message
          [formField]="revocationForm.get('bookingNumber')"></app-error-message>
      </div>
      <div class="input-simple align-self-stretch">
        <div class="input-label" for="email">
          E-Mail{{ fieldRequired(revocationForm.get('email')) ? '*' : '' }}
        </div>
        <input
          id="email"
          class="input-field"
          formControlName="email"
          name="email"
          type="email"
          autocomplete="email"
          placeholder="E-Mail" />
        <app-error-message
          [formField]="revocationForm.get('email')"></app-error-message>
      </div>
      @if (errorMessage) {
        <div
          class="inwi-text-error font-regular-label-large align-self-stretch">
          {{ errorMessage }}
        </div>
      }
      <div class="flex-r gap-16 justify-center align-self-stretch">
        <button
          type="button"
          class="inwi-text-button-large-secondary flex-1-0-0"
          (click)="closeDialog()">
          <div class="button-content">
            <div class="button-text">Abbrechen</div>
          </div>
        </button>
        <button
          type="submit"
          class="inwi-text-button-large-primary flex-1-0-0"
          [disabled]="revocationForm.invalid">
          <div class="button-content">
            <div class="button-text">Weiter</div>
          </div>
        </button>
      </div>
    </form>
  } @else if (preview) {
    <div class="text-container">
      <span class="font-medium-display-small text-align-center">
        Widerruf bestätigen
      </span>
      <span class="font-regular-body-large text-align-center">
        Bitte prüfe die Angaben zu deiner Buchung und den voraussichtlichen
        Stornokosten.
      </span>
    </div>
    <div class="preview-container">
      <div class="preview-section">
        <span class="font-medium-title-medium section-title">Buchung</span>
        <div class="preview-row">
          <span class="font-medium-body">Buchungsnummer</span>
          <span class="font-regular-body-large">{{ preview.bookingNr }}</span>
        </div>
      </div>

      <div class="preview-section">
        <span class="font-medium-title-medium section-title"
          >Gebuchtes Seminar</span
        >
        <div class="preview-row">
          <span class="font-medium-body">Seminar</span>
          <span class="font-regular-body-large">{{
            preview.seminarTitle
          }}</span>
        </div>
        @if (preview.seminarSeriesName) {
          <div class="preview-row">
            <span class="font-medium-body">Terminserie</span>
            <span class="font-regular-body-large">{{
              preview.seminarSeriesName
            }}</span>
          </div>
        }
        @for (date of preview.seminarDates; track $index) {
          <div class="preview-row">
            <span class="font-medium-body">Teil {{ $index + 1 }}</span>
            <span class="font-regular-body-large">
              {{ date.startDate | date: 'dd. MMMM yyyy HH:mm' }} –
              {{ date.endDate | date: 'HH:mm' }} Uhr
            </span>
          </div>
        }
      </div>

      <div class="preview-section">
        <span class="font-medium-title-medium section-title">Teilnehmer</span>
        @for (participant of preview.participants; track $index) {
          <div class="participant-item">
            <span class="font-regular-body-large">
              {{ participant.firstName }} {{ participant.lastName }}
            </span>
            <span class="font-regular-body-large participant-detail">
              {{ getParticipantConditionLabel(participant.condition) }}
              ({{ participant.conditionPrice | currency: 'EUR' }})
            </span>
          </div>
        }
      </div>

      <div class="preview-section">
        <span class="font-medium-title-medium section-title"
          >Buchungskosten</span
        >
        @if (shouldShowPriceBreakdown(preview)) {
          <div class="preview-row">
            <span class="font-medium-body">Gesamtbetrag</span>
            <span class="font-regular-body-large">
              {{ preview.totalPrice | currency: 'EUR' }}
            </span>
          </div>
          @for (coupon of preview.coupons; track coupon.id) {
            <div class="preview-row coupon-row">
              <span class="font-medium-body">Gutschein: {{ coupon.code }}</span>
              <span class="font-regular-body-large coupon-discount">
                -{{ getCouponDiscountAmount(coupon) | currency: 'EUR' }}
              </span>
            </div>
          }
          <div class="preview-row">
            <span class="font-medium-body">Zu zahlender Betrag</span>
            <span class="font-regular-body-large">
              {{ getFinalPrice(preview) | currency: 'EUR' }}
            </span>
          </div>
          @if (preview.discountedPrice < 0) {
            <div class="info-box font-regular-body-large">
              Nach erfolgreicher Anmeldung wird dir ein Gutschein im Wert von
              {{ preview.discountedPrice * -1 | currency: 'EUR' }}
              ausgestellt.
            </div>
          }
        } @else {
          <div class="preview-row">
            <span class="font-medium-body">Gesamtbetrag</span>
            <span class="font-regular-body-large">
              {{ preview.discountedPrice | currency: 'EUR' }}
            </span>
          </div>
        }
        <div class="preview-row">
          <span class="font-medium-body">Zahlungsstatus</span>
          <span class="font-regular-body-large">{{
            preview.paymentStatusLabel
          }}</span>
        </div>
      </div>

      <div class="preview-section">
        <span class="font-medium-title-medium section-title">Stornierung</span>
        <div class="preview-row">
          <span class="font-medium-body">Stornoregel</span>
          <span class="font-regular-body-large">{{
            preview.cancelOptionLabel
          }}</span>
        </div>
        <div class="preview-row">
          <span class="font-medium-body">Stornierungsgebühr</span>
          <span class="font-regular-body-large">
            {{ preview.cancellationFee | currency: 'EUR' }}
          </span>
        </div>
        <div class="preview-row settlement-row">
          <span class="font-medium-body">{{ preview.settlementLabel }}</span>
          <span
            class="font-medium-title-medium"
            [class.settlement-payment]="preview.settlementType === 'payment'"
            [class.settlement-refund]="preview.settlementType === 'refund'">
            @if (preview.settlementType === 'none') {
              {{ preview.settlementAmount | currency: 'EUR' }}
            } @else {
              {{ preview.settlementAmount | currency: 'EUR' }}
            }
          </span>
        </div>
        @if (preview.isPaid && preview.settlementType === 'refund') {
          <div class="info-box font-regular-body-large">
            Da die Buchung bereits bezahlt wurde, erhältst du eine Erstattung in
            Höhe von {{ preview.settlementAmount | currency: 'EUR' }}.
          </div>
        }
        @if (!preview.isPaid && preview.settlementType === 'payment') {
          <div class="info-box font-regular-body-large">
            Da die Buchung noch nicht bezahlt wurde, sind nach dem Widerruf noch
            {{ preview.settlementAmount | currency: 'EUR' }} zu zahlen.
          </div>
        }
        @if (preview.withinRevocationPeriod) {
          <div class="info-box font-regular-body-large">
            Innerhalb von 14 Tagen nach der Buchung ist der Widerruf für dich
            kostenfrei.
          </div>
        }
      </div>
    </div>
    @if (errorMessage) {
      <div class="inwi-text-error font-regular-label-large align-self-stretch">
        {{ errorMessage }}
      </div>
    }
    <div class="flex-r gap-16 justify-center align-self-stretch">
      <button
        type="button"
        class="inwi-text-button-large-secondary flex-1-0-0"
        (click)="backToForm()">
        <div class="button-content">
          <div class="button-text">Zurück</div>
        </div>
      </button>
      <button
        type="button"
        class="inwi-text-button-large-primary flex-1-0-0"
        (click)="confirmRevocation()">
        <div class="button-content">
          <div class="button-text">Vertrag widerrufen</div>
        </div>
      </button>
    </div>
  }
</div>
